"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const just_validate_1 = __importDefault(require("just-validate"));
const errorMessages = {
    es: {
        required: "Campo requerido",
        email: "Por favor, introduzca un correo electrónico válido",
    },
    en: {
        required: "Required field",
        email: "Please enter a valid email",
    },
};
function initForms(formsClasses) {
    const locale = window.location.pathname.includes("/en/") ? "en" : "es";
    const formsEls = document.querySelectorAll(formsClasses);
    formsEls.forEach(function (form) {
        const inputEls = form.querySelectorAll("input, textarea, select");
        const generateRules = function (input) {
            const rules = [];
            if (input.required) {
                // @ts-ignore
                rules.push({ rule: "required", errorMessage: errorMessages[locale].required });
            }
            if (input.type === "email") {
                // @ts-ignore
                rules.push({ rule: "email", errorMessage: errorMessages[locale].email });
            }
            // Add other specific rules here based on input attributes or classes
            return rules;
        };
        const formConfig = {
            errorFieldCssClass: "--error",
            errorLabelCssClass: "error-tag tag",
        };
        const formValidator = new just_validate_1.default(form, formConfig);
        inputEls.forEach((input) => {
            const rules = generateRules(input);
            if (rules.length > 0) {
                formValidator.addField(input, rules);
            }
        });
        formValidator.onSuccess((event) => {
            const form = event === null || event === void 0 ? void 0 : event.currentTarget;
            // @ts-ignore
            const url = form.dataset.action;
            // @ts-ignore
            const tyPage = form.dataset.typage;
            // @ts-ignore
            const data = new FormData(form);
            function sendForm() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const response = yield fetch(url, { method: "POST", body: data });
                        if (!response.ok) {
                            throw new Error("Request error: " + response.statusText);
                        }
                        if (tyPage) {
                            window.location.href = tyPage;
                        }
                    }
                    catch (error) {
                        console.error("An error occurred while submitting the form: ", error);
                    }
                });
            }
            sendForm();
        });
    });
}
exports.default = initForms;
